/** O que falta nos dados da clínica, por campo — a mesma regra da tela, da demonstração e do banco (0051). */
export interface FaltasDaClinica {
    nome?: string;
    documento?: string;
    telefone?: string;
}

/**
 * Nome fantasia, documento e telefone da unidade: a tela marcava os três como
 * obrigatórios e gravava vazio mesmo assim.
 */
export function faltasDaClinica(
    clinica: { nome?: string; documento?: string; tipoPessoa?: string },
    unidade?: { telefone?: string },
): FaltasDaClinica {
    const faltas: FaltasDaClinica = {};
    if (!clinica.nome?.trim()) faltas.nome = 'O nome fantasia é obrigatório.';
    if (!clinica.documento?.trim()) faltas.documento = `O ${clinica.tipoPessoa === 'fisica' ? 'CPF' : 'CNPJ'} é obrigatório.`;
    if (unidade && !unidade.telefone?.trim()) faltas.telefone = 'O telefone da unidade é obrigatório.';
    return faltas;
}

export function primeiraFalta(faltas: FaltasDaClinica): string | null {
    return faltas.nome ?? faltas.documento ?? faltas.telefone ?? null;
}
